import styled from "styled-components";

export const SwipeDiv = styled.div<{ active: boolean }>`
  position: fixed;
  right: 0;
  width: 100vw;
  height: 100%;
  background: white;
  color: black;
  display: flex;
  flex-direction: column;
  transition: transform 0.25s ease-out;
  transform: translateX(100%);
  pointer-events: ${({ active }) => (active ? "auto" : "none")};
  z-index: 900;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const Wrapper = styled.div`
  max-width: 95vw;
  margin: 1rem auto;
`;

export const HeroWrapper = styled.div`
  margin: 2rem auto;
  width: 100%;
`;

export const NextButton = styled.button`
  top: 50vh;
  transform: translateY(-50%);
  right: 100%;
  position: fixed;
  padding: 0.85rem 0 0.85rem 0.85rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: black;
  color: white;
  border: none;
  border-radius: 99999px 0 0 99999px;
  z-index: 999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: background 0.2s ease;
  height: 86px;
  opacity: 50%;

  &:hover {
    background: #333;
  }
`;
